import React, { useState, useEffect } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { createTrainee, getAllLawyers, NewTraineeData } from '../../../services/traineeService';
import { Lawyer } from '../../../types/lawyer';
import styles from './TraineeForm.module.css'; // استيراد الأنماط الجديدة

const AddTraineePage: React.FC = () => {
  const navigate = useNavigate();
  const [lawyers, setLawyers] = useState<Lawyer[]>([]);
  const { 
    register, 
    handleSubmit, 
    formState: { errors, isSubmitting } 
  } = useForm<NewTraineeData>();

  // جلب قائمة المحامين عند تحميل الصفحة
  useEffect(() => {
    const fetchLawyers = async () => {
      try {
        const lawyersData = await getAllLawyers();
        setLawyers(lawyersData);
      } catch (error) {
        toast.error('فشل في جلب قائمة المحامين.');
      }
    };
    fetchLawyers();
  }, []);

  const onSubmit: SubmitHandler<NewTraineeData> = async (data) => {
    // تحويل القيم الرقمية قبل الإرسال
    const submissionData = {
      ...data,
      user_id: Number(data.user_id),
      lawyer_id: Number(data.lawyer_id),
    };

    const promise = createTrainee(submissionData);

    toast.promise(promise, {
      loading: 'جاري حفظ المتدرب...',
      success: () => {
        navigate('/trainees'); // العودة إلى القائمة بعد النجاح
        return 'تمت إضافة المتدرب بنجاح!';
      },
      error: (err) => err.response?.data?.message || 'فشل في إنشاء المتدرب.',
    });
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.formContainer}>
        <h2 className={styles.title}>إضافة متدرب جديد</h2>
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          
          {/* اسم المتدرب */}
          <div className={styles.formField}>
            <label htmlFor="name" className={styles.label}>اسم المتدرب</label>
            <input id="name" type="text" {...register('name', { required: 'الاسم مطلوب' })} className={styles.input} />
            {errors.name && <p className={styles.error}>{errors.name.message}</p>}
          </div>

          {/* رقم المتدرب */}
          <div className={styles.formField}>
            <label htmlFor="trainee_number" className={styles.label}>رقم المتدرب</label>
            <input id="trainee_number" type="text" {...register('trainee_number', { required: 'رقم المتدرب مطلوب' })} className={styles.input} />
            {errors.trainee_number && <p className={styles.error}>{errors.trainee_number.message}</p>}
          </div>

          {/* معرف المستخدم */}
          <div className={styles.formField}>
            <label htmlFor="user_id" className={styles.label}>معرف المستخدم (User ID)</label>
            <input id="user_id" type="number" {...register('user_id', { required: 'معرف المستخدم مطلوب', valueAsNumber: true })} className={styles.input} />
            {errors.user_id && <p className={styles.error}>{errors.user_id.message}</p>}
          </div>

          {/* المحامي المشرف */}
          <div className={styles.formField}>
            <label htmlFor="lawyer_id" className={styles.label}>المحامي المشرف</label>
            <select id="lawyer_id" {...register('lawyer_id', { required: 'يجب اختيار محامٍ', valueAsNumber: true })} className={styles.input}>
              <option value="" disabled>-- اختر محاميًا --</option>
              {lawyers.map(lawyer => (
                <option key={lawyer.id} value={lawyer.id}>
                  {lawyer.name}
                </option>
              ))}
            </select>
            {errors.lawyer_id && <p className={styles.error}>{errors.lawyer_id.message}</p>}
          </div>

          {/* تاريخ البدء */}
          <div className={styles.formField}>
            <label htmlFor="start_date" className={styles.label}>تاريخ البدء</label>
            <input id="start_date" type="date" {...register('start_date', { required: 'تاريخ البدء مطلوب' })} className={styles.input} />
            {errors.start_date && <p className={styles.error}>{errors.start_date.message}</p>}
          </div>

          {/* تاريخ الانتهاء */}
          <div className={styles.formField}>
            <label htmlFor="end_date" className={styles.label}>تاريخ الانتهاء</label>
            <input id="end_date" type="date" {...register('end_date', { required: 'تاريخ الانتهاء مطلوب' })} className={styles.input} />
            {errors.end_date && <p className={styles.error}>{errors.end_date.message}</p>}
          </div>

          {/* أزرار الإرسال والإلغاء */}
          <div className={styles.buttonContainer}>
            <Link to="/admin/trainees/list" className={styles.cancelButton}>إلغاء</Link>
            <button type="submit" disabled={isSubmitting} className={styles.submitButton}>
              {isSubmitting ? 'جاري الحفظ...' : 'حفظ المتدرب'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTraineePage;
